module.exports = __webpack_public_path__ + "img/به-انتخاب-طراح.e5b86db8.png";